import { Nullable } from '../types/typeish.type';

export enum IntegrationCodeType {
  FLIKO = 'fliko',
  SAP = 'sap',
  MIESZCZANIN = 'mieszczanin',
  WELES = 'weles',
  WEBCON = 'webcon',
  WEBCON_DEFECT = 'webcon_defect',
  LEGACY = 'legacy',
  OTHER = 'other'
}

export type IntegrationCode = {
  [key in IntegrationCodeType]?: string | null;
};

export namespace IntegrationCode {
  /**
   * All values of  IntegrationCodeType
   * @return {string[]}
   */
  export function enumValues(): `${IntegrationCodeType}`[] {
    return Object.values(IntegrationCodeType);
  }

  /**
   * Extract integration key from any object
   * @param {object} data
   * @param {K} key
   * @param {L} legacyKey
   * @return {string | null}
   */
  export function fromData<K extends string, L extends string>(
    data: { [k in K]: Nullable<IntegrationCode> } & { [l in L]: Nullable<string> },
    key: K,
    legacyKey: L
  ): string | null {
    return IntegrationCode.fromIntegrationCode(data[key]) || data[legacyKey] || null;
  }

  /**
   * Return single integration code (use only if one code on estate is guaranteed)
   * @param {Nullable<IntegrationCode>} obj
   * @return {string | null}
   */
  export function fromIntegrationCode(obj: Nullable<IntegrationCode>): string | null {
    if (!obj) return null;
    return (
      obj.sap ?? obj.mieszczanin ?? obj.weles ?? obj.webcon ?? obj.webcon_defect ?? obj.other ?? obj.fliko ?? obj.legacy ?? null
    );
  }

  /**
   * Return all unique values in obj
   * @param {Nullable<IntegrationCode>} obj
   * @return {Set<string>}
   */
  export function allCodesFromObj(obj: Nullable<IntegrationCode>): Set<string> {
    const ret = new Set<string>();
    if (obj) {
      const types = IntegrationCode.enumValues();
      types.forEach((t) => {
        const val = obj[t as IntegrationCodeType];
        if (val) ret.add(val);
      });
    }
    return ret;
  }
}
